/**
 * ttx.tabs — 页签状态桥接模块
 *
 * 作为 Transfer（状态管理者）与 ServiceTabs（UI 渲染者）之间的通信桥梁。
 * Transfer 通过 register() 注册状态获取函数和操作方法，
 * ServiceTabs 通过 subscribe() 订阅状态变化。
 *
 * 状态结构：{ panes, activeKey, isFullscreen }
 */
window.ttx = window.ttx || {};
window.ttx.tabs = (function () {
    var _subscribers = [];
    var _state = { panes: [], activeKey: null, isFullscreen: false };
    var _actions = null;

    function notify() {
        for (var i = 0; i < _subscribers.length; i++) {
            try { _subscribers[i](_state); } catch (e) {}
        }
    }

    var api = {
        /**
         * 注册页签状态和操作方法（由 Transfer 调用）
         * @param {Object} actions
         *   getPanes, getActiveKey, getIsFullscreen — 状态获取函数
         *   switchTo, close, closeOther, closeAll, refresh, openNewWindow,
         *   addTab, reorder, togglePin, toggleFullscreen — 操作方法
         */
        register: function (actions) {
            _actions = actions;
            _state = {
                panes: actions.getPanes() || [],
                activeKey: actions.getActiveKey() || null,
                isFullscreen: actions.getIsFullscreen ? actions.getIsFullscreen() : false,
            };
            notify();
        },

        /**
         * 更新状态（由 Transfer 在状态变化时调用）
         */
        update: function (partial) {
            _state = {
                panes: partial.panes !== undefined ? partial.panes : _state.panes,
                activeKey: partial.activeKey !== undefined ? partial.activeKey : _state.activeKey,
                isFullscreen: partial.isFullscreen !== undefined ? partial.isFullscreen : _state.isFullscreen,
            };
            notify();
        },

        /**
         * 订阅状态变化（由 ServiceTabs 调用）
         * @returns {Function} 取消订阅函数
         */
        subscribe: function (cb) {
            _subscribers.push(cb);
            // 立即推送一次当前状态
            try { cb(_state); } catch (e) {}
            return function () {
                var idx = _subscribers.indexOf(cb);
                if (idx > -1) _subscribers.splice(idx, 1);
            };
        },

        /** 获取当前状态快照 */
        getState: function () { return _state; },

        // ===== 操作方法代理 =====
        switchTo: function (key) { _actions && _actions.switchTo && _actions.switchTo(key); },
        close: function (key) { _actions && _actions.close && _actions.close(key); },
        closeOther: function (key) { _actions && _actions.closeOther && _actions.closeOther(key); },
        closeAll: function () { _actions && _actions.closeAll && _actions.closeAll(); },
        refresh: function (key) { _actions && _actions.refresh && _actions.refresh(key); },
        openNewWindow: function (key) { _actions && _actions.openNewWindow && _actions.openNewWindow(key); },
        addTab: function () { _actions && _actions.addTab && _actions.addTab(); },
        reorder: function (fromKey, toKey, insertBefore) {
            _actions && _actions.reorder && _actions.reorder(fromKey, toKey, insertBefore);
        },
        togglePin: function (key) { _actions && _actions.togglePin && _actions.togglePin(key); },
        toggleFullscreen: function () { _actions && _actions.toggleFullscreen && _actions.toggleFullscreen(); },
    };

    return api;
})();
